import { useTranslation } from "react-i18next"

import { CustomerDetails } from "@/components/customers/details"
import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"

export function CustomerDetailsPage() {
  const { t } = useTranslation()

  return (
    <DashboardContainer>
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              href: FRONTEND_ROUTES.CUSTOMERS.href,
              label: t("sidebar.customers"),
            },
            {
              label: t("pages.customers.customerDetails"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <CustomerDetails />
      </section>
    </DashboardContainer>
  )
}
